import { render, staticRenderFns } from "./UpscaleRegionsPanel.vue?vue&type=template&id=35a3ea0f&scoped=true"
import script from "./UpscaleRegionsPanel.vue?vue&type=script&lang=js"
export * from "./UpscaleRegionsPanel.vue?vue&type=script&lang=js"
import style0 from "./UpscaleRegionsPanel.vue?vue&type=style&index=0&id=35a3ea0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3ea0f",
  null
  
)

export default component.exports